import { ActionWithPayload as Action } from "common/types/redux";

import { ClassLeaderboard } from "services/classLeaderboardsService/types";

import actionTypes from "../../../action-types";
import ClassLeaderboardsHistory from "../../../models/classLeaderboardsHistory";

export default function classLeaderboardsHistoryReducer(
  history: ClassLeaderboardsHistory = new ClassLeaderboardsHistory(),
  action: Action<
    any & {
      classId: string;
    }
  >
) {
  switch (action.type) {
    case actionTypes.RECEIVE_LEADERBOARD:
      return updateLeaderboardHistory(history, action.payload);

    default:
      return history;
  }
}

function updateLeaderboardHistory(
  { currentLeaderboards, previousLeaderboards }: ClassLeaderboardsHistory,
  payload: ClassLeaderboard
) {
  const { classId } = payload;
  const oldLeaderboard = currentLeaderboards.get(classId, payload);

  return new ClassLeaderboardsHistory({
    currentLeaderboards: currentLeaderboards.set(classId, payload),
    previousLeaderboards: previousLeaderboards.set(classId, oldLeaderboard)
  });
}
